module.exports = __webpack_public_path__ + "img/9_31.268180de.png";